import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
export const FittingRoomContext = createContext(undefined);
export function useFittingRoomPopupOpener() {
    return useContext(FittingRoomContext);
}
